import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["unitId"];
import { toJS } from 'mobx';
import useStyles from './styles';
import { UnitForm } from './UnitForm';
import { useStore } from 'src/stores';
import { isConvergentExportEnabled } from 'src/utils/convergentExport';
import { Button, Chip, MenuItem } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader, Icon, SelectMenu, toast } from '@livable/saas-react-components';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { PmsUnitMappingModal } from 'src/components/property/PropertyUnitSetupPage/PmsUnitMappingModal';
export const UnitModalContent = observer(_ref => {
  var _store$company$proper, _store$company$proper2, _store$homeDashboardS, _store$homeDashboardS0, _store$homeDashboardS1, _store$homeDashboardS10;
  let handleClose = _ref.handleClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoaded = _useState4[0],
    setIsLoaded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSubmited = _useState6[0],
    setIsSubmited = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    requiredSquareFootage = _useState8[0],
    setRequiredSquareFootage = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    utilityType = _useState0[0],
    setUtilityType = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isPmsMappingOpen = _useState10[0],
    setIsPmsMappingOpen = _useState10[1];

  // The mapping exists to serve the convergent charge export, so it lives behind the same gate as
  // the export button, plus a PMS to map to.
  const pms = (_store$company$proper = (_store$company$proper2 = store.company.propertyManagementSoftware) === null || _store$company$proper2 === void 0 ? void 0 : _store$company$proper2.trim()) !== null && _store$company$proper !== void 0 ? _store$company$proper : '';
  const showPmsUnitId = isConvergentExportEnabled(store, (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.dashboard) && pms.length > 0 && pms.toLowerCase() !== 'none';
  const unitSetup = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup;
  const isSubmitDisabled = () => {
    let result = false;
    for (var i = 0; i < store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.unitsValidation.length; i++) {
      for (const _ref2 of Object.entries(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.unitsValidation[i])) {
        var _ref3 = _slicedToArray(_ref2, 2);
        const value = _ref3[1];
        if (value === false) {
          result = true;
          break;
        }
      }
    }
    return result;
  };
  const handleSubmit = async () => {
    var _store$homeDashboardS2;
    setIsSubmited(true);
    if (requiredSquareFootage) {
      for (let i = 0; i < store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units.length; i++) {
        const element = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[i];
        if (!(element.square > 0)) {
          store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.validateValue(i, 'square', false);
        }
      }
    }
    if (isSubmitDisabled()) return;
    const unitsToUpdateList = [...toJS(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.savedUnits)];
    const temporaryData = [];
    const data = {
      buildingId: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.buildingInformation) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id,
      units: {
        toCreate: [],
        toUpdate: [],
        toDelete: []
      }
    };
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units.map(item => {
      const itemAmenities = [];
      item.amenities.map(amenityItem => {
        itemAmenities.push({
          inUnitAmenityId: amenityItem.inUnitAmenityId,
          inUnitAmenityOptionId: amenityItem.inUnitAmenityOptionId
        });
      });
      temporaryData.push({
        unitId: item.id,
        name: item.name.trim(),
        occupancy: +item.occupancy,
        squareFootage: +item.square,
        type: item.type,
        inUnitAmenities: itemAmenities,
        optOutUtilityIds: item.disabledOptOutUtilityIds.slice(),
        unitUtilities: item.unitUtilities.slice()
      });
    });

    // Which row of the list each created unit came from, in the order the request sends them —
    // the response returns the new ids in that same order, and nothing else ties them to a row.
    const createdFromIndex = [];
    temporaryData.forEach((item, index) => {
      const coincidenceIndex = unitsToUpdateList.findIndex(feeItem => feeItem.id === item.unitId);
      if (coincidenceIndex !== -1) {
        data.units.toUpdate.push(item);
        unitsToUpdateList.splice(coincidenceIndex, 1);
      } else {
        const unitId = item.unitId,
          currentItem = _objectWithoutProperties(item, _excluded);
        data.units.toCreate.push(currentItem);
        createdFromIndex.push(index);
      }
    });
    unitsToUpdateList.map(item => {
      data.units.toDelete.push(item.id);
    });
    const resp = await store.units.updateUnitsAsync.run(data);
    if (resp && resp.isSuccessful) {
      var _store$homeDashboardS3, _store$homeDashboardS4;
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.initIdsAfterAddingUnits(resp.response);

      // A second call, and deliberately so: the unit PATCH above rebuilds each unit from the
      // whole model, while this one touches the PMS columns alone.
      //
      // The ids come from what was sent plus what came back, not from the store: the line above
      // writes the created ids into units[0..n] by position, which is only the right row when
      // every unit is new.
      if (showPmsUnitId) {
        const unitIds = temporaryData.map(item => item.unitId);
        createdFromIndex.forEach((unitIndex, createdIndex) => {
          var _resp$response;
          unitIds[unitIndex] = (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response[createdIndex];
        });
        const mappings = unitIds.map((unitId, index) => {
          var _unitSetup$units$inde, _unitSetup$units$inde2, _unitSetup$units$inde3, _unitSetup$units$inde4;
          return {
            unitId,
            pmsUnitId: (_unitSetup$units$inde = (_unitSetup$units$inde2 = unitSetup.units[index]) === null || _unitSetup$units$inde2 === void 0 ? void 0 : _unitSetup$units$inde2.pmsUnitId) !== null && _unitSetup$units$inde !== void 0 ? _unitSetup$units$inde : '',
            pmsUnitName: (_unitSetup$units$inde3 = (_unitSetup$units$inde4 = unitSetup.units[index]) === null || _unitSetup$units$inde4 === void 0 ? void 0 : _unitSetup$units$inde4.pmsUnitName) !== null && _unitSetup$units$inde3 !== void 0 ? _unitSetup$units$inde3 : ''
          };
        }).filter(mapping => mapping.unitId && mapping.unitId !== 'null');
        if (mappings.length > 0) {
          const mappingResp = await store.units.updateUnitPmsMappingsAsync.run({
            buildingId: data.buildingId,
            mappings
          });

          // The async model raises its own error toast and resolves to undefined on failure.
          // Falling through would print "Successfully saved" over that error and close the modal
          // on a mapping the server refused (LB-5999). What the PM typed stays on screen, so the
          // snapshot taken at open is deliberately not applied here either.
          if (!(mappingResp !== null && mappingResp !== void 0 && mappingResp.isSuccessful)) {
            // The units themselves did save, so the baseline a second attempt diffs against has
            // to catch up with them: a unit created a moment ago is not in savedUnits yet, and
            // saving again would send it as a creation a second time.
            const refreshed = await store.units.getUnitsAsync.run({
              applyToHomeDashboard: false,
              buildingId: data.buildingId
            });
            if (refreshed !== null && refreshed !== void 0 && refreshed.response) unitSetup.setUnitsAfterLoad(refreshed);
            return;
          }
        }
      }
      await store.units.getUnitsAsync.run({
        applyToHomeDashboard: true,
        buildingId: (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.buildingInformation) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.id
      });
      toast('success', {
        body: ['Successfully saved']
      });
      (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || _store$homeDashboardS4.selectedPropertyDetails().details.unitSetup.initAfterLoadState();
      handleClose({
        triggerRefresh: true
      });
    } else {
      var _store$homeDashboardS5;
      (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || _store$homeDashboardS5.selectedPropertyDetails().details.unitSetup.applyAfterLoadState();
    }
  };
  const startRerender = () => {
    setIsLoaded(true);
    setTimeout(() => {
      setIsLoaded(false);
    }, 100);
  };
  const fetchData = async () => {
    var _store$homeDashboardS6;
    await store.inUnitAmenities.getAllInUnitAmenitiesAsync.run({
      applyToHomeDashboardStore: true
    });
    const utilities = await store.properties.getPropertyUtilityProvidersV3Async.run({
      propertyId: (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.id
    });
    for (let i = 0; i < (utilities === null || utilities === void 0 || (_utilities$response = utilities.response) === null || _utilities$response === void 0 ? void 0 : _utilities$response.length); i++) {
      var _utilities$response;
      const result = utilities.response[i].utilities.some(item => item.allocationMethod === ALLOCATION_METHOD.BySquareFootage || item.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage);
      if (result) {
        setRequiredSquareFootage(true);
        break;
      }
    }
    setIsLoaded(true);
  };
  useEffect(() => {
    var _store$homeDashboardS7, _store$homeDashboardS8;
    fetchData();
    const utilityTemplatesIdx = (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.details) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.utilityTemplates) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.findIndex(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare);
    if (utilityTemplatesIdx !== -1) {
      setUtilityType(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.utilityTemplates[utilityTemplatesIdx].utilityId);
    }
    (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS8 === void 0 || _store$homeDashboardS8.selectedPropertyDetails().details.unitSetup.initAfterLoadState();
    return () => {
      var _store$homeDashboardS9;
      (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS9 === void 0 || _store$homeDashboardS9.selectedPropertyDetails().details.unitSetup.applyAfterLoadState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, showPmsUnitId && /*#__PURE__*/React.createElement("div", {
    className: classes.pmsMapping
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.pmsMappingCount
  }, unitSetup.mappedUnitsCount, " of ", unitSetup.units.length, " units mapped to ", pms), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => setIsPmsMappingOpen(true),
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    'custom-attribute': '692-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "upload"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Map from CSV')))), ((_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.details) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.utilityTemplates) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.findIndex(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare)) !== -1 && /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info",
      state: "info"
    }),
    label: t('Some utilities use a percentage-based allocation method. Please enter the percentage values for the units below.'),
    variant: "info"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.contentList
  }, store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, ((_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.details) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.utilityTemplates) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.findIndex(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare)) !== -1 && /*#__PURE__*/React.createElement("div", {
    className: classes.contentRow
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "unit-modal-utility-type-selector",
    labelId: "unit-modal-utility-type-selector-label",
    label: t('Allocation method'),
    value: utilityType,
    onChange: e => setUtilityType(e.target.value || ''),
    displayEmpty: true
  }, (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.details) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.utilityTemplates) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.filter(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare)) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.map(utilityItem => /*#__PURE__*/React.createElement(MenuItem, {
    key: utilityItem.utilityId,
    value: utilityItem.utilityId
  }, utilityItem.utilityType, " (", utilityItem.provider.utilityProviderName, ")")))), store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units.map((elem, i) => {
    return /*#__PURE__*/React.createElement(UnitForm, {
      key: i,
      unitIndex: i,
      isLoaded: isLoaded,
      isSubmited: isSubmited,
      unitTypeProp: elem.type,
      utilityType: utilityType,
      _startRerender: startRerender,
      showPmsUnitId: showPmsUnitId,
      requiredSquareFootage: requiredSquareFootage
    });
  })))), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.contentSetting
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.addUnitsCount(1);
    },
    'custom-attribute': '684-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Add unit')))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: showMenu ? 'active' : '',
    onClick: () => setShowMenu(!showMenu),
    'custom-attribute': '685-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down"
  })), showMenu && /*#__PURE__*/React.createElement("div", {
    className: classes.menuBlockControls
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.addUnitsCount(10);
      setShowMenu(!showMenu);
    },
    'custom-attribute': '686-new-billing-module'
  }, "Add 10 units"), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.addUnitsCount(25);
      setShowMenu(!showMenu);
    },
    'custom-attribute': '687-new-billing-module'
  }, "Add 25 units"), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.addUnitsCount(50);
      setShowMenu(!showMenu);
    },
    'custom-attribute': '688-new-billing-module'
  }, "Add 50 units"), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.addUnitsCount(100);
      setShowMenu(!showMenu);
    },
    'custom-attribute': '689-new-billing-module'
  }, "Add 100 units")))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleClose,
    'custom-attribute': '690-new-billing-module'
  }, t('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: () => handleSubmit(),
    'custom-attribute': '691-new-billing-module'
  }, t('Save units')))))), showPmsUnitId && /*#__PURE__*/React.createElement(PmsUnitMappingModal, {
    isOpen: isPmsMappingOpen,
    onClose: () => setIsPmsMappingOpen(false),
    units: unitSetup.units,
    onApply: mappings => unitSetup.applyPmsMappings(mappings)
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.units.getUnitsAsync.inProgress || store.units.updateUnitPmsMappingsAsync.inProgress || store.units.updateUnitsAsync.inProgress || store.inUnitAmenities.getAllInUnitAmenitiesAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress
  }));
});